import React from "react"
import {useGetSelfEmployeeQuery} from "../../store/api/employeeApi";
import LoadingBlock from "../../components/loader/LoadingBlock";
import ErrorBadGateway from "../../components/error/ErrorBadGateway";
import ErrorAccessDenied from "../../components/error/ErrorAccessDenied";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const PermissionProvider: React.FC<PermissionProviderProps> = ({children}) => {
    const {data, isLoading, isError} = useGetSelfEmployeeQuery()

    if (isLoading) return <LoadingBlock/>

    if (isError) return <ErrorBadGateway/>

    if (data?.data?.accounts.length === 0 && data?.data?.permission?.can_read_account === false) return <ErrorAccessDenied/>

    return (
        <>
            {children}
        </>
    )
}

export default PermissionProvider
